import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"
import { cn } from "../utils"

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-md border text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 shadow-xs",
  {
    variants: {
      size: {
        default: "px-2.5 py-0.5",
        sm: "px-1.5 py-0",
      },
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground",
        outline: "bg-background",
        gradient: "badge-gradient-primary",
        success: "border-success bg-background text-success",
        cached: "border-muted-foreground bg-background text-muted-foreground",
        unsuccess: "border-testing-1 bg-background text-testing-1",
        negative: "border-destructive bg-background text-destructive",
        testing: "badge-gradient-testing",
        warning: "border-warning bg-background text-warning",
      },
    },
    defaultVariants: {
      size: "default",
      variant: "default",
    },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant, size }), className)} {...props}>
      {props.children}
    </div>
  )
}

export { Badge, badgeVariants }
